import { useStyles } from "./style";
import React, { ReactElement } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import Typography from "@mui/material/Typography";

const getStatusClassName = (status) => {
  switch (status) {
      case 'PendingAuth':
          return 'pending-auth'

      case 'Deauthorized':
          return 'de-authorized'

      case 'LOW':
      case true:
      case 'Generated':
      case 'Linked':
      case 'Active':
          return 'success'

      case 'HIGH':
      case 'Missing':
          return 'danger'

      case 'MEDIUM':
      case 'Pending Renewal':
          return 'warning'
      default:
          return 'default'
  }
};

interface StatusTagProps {
    status: string
    caseName?: string
    className?: string
    children?: ReactElement
}

export const StatusTag: React.FC<StatusTagProps> = ({ status = null, caseName, className, children = null }): ReactElement => {
    const styles = useStyles()
    switch (caseName || status) {
        case 'bookClosureStatus':
            return (
                <>
                    <div className={styles.statusTagWrapper}>
                        <CircleIcon className={getStatusClassName(status)}></CircleIcon>
                        <Typography style={{ opacity: status ? 1 : 0.6, textTransform: 'capitalize' }}>
                            {status?.toLowerCase() || 'N/A'}
                        </Typography>
                    </div>
                </>
            )
        case 'isMonthlyRefreshEnabled':
            return (
                <>
                    <div className={styles.statusTagWrapper}>
                        <CircleIcon className={getStatusClassName(status)}></CircleIcon> <p>{status ? 'Enabled' : 'Disabled'}</p>
                    </div>
                </>
            )
        case 'workbookStatus':
            return (
                <>
                    <div className={styles.statusTagWrapper} style={{ textTransform: 'none' }}>
                        <CircleIcon className={getStatusClassName(status)}></CircleIcon>
                        <Typography style={{ opacity: status === 'N/A' || !status ? 0.6 : 1 }}>
                            {status || 'N/A'} {children}
                        </Typography>
                    </div>
                </>
            )
        case 'connectionStatus':
            return (
                <>
                    <div className={styles.statusTagWrapper}>
                        <CircleIcon className={getStatusClassName(status)}></CircleIcon>
                        <Typography>{status || 'Not Connected'}</Typography>
                    </div>
                </>
            )
        case 'clientStatus':
            return (
                <>
                    {status && (
                        <div className={styles.statusTagWrapper}>
                            <CircleIcon className={getStatusClassName(status)}></CircleIcon>
                            <Typography>
                                {status || ''} {children}
                            </Typography>
                        </div>
                    )}
                </>
            )
        default:
            return (
                <>
                    <div className={styles.statusTagWrapper}>
                        <CircleIcon className="default"></CircleIcon> <p>N/A</p>
                    </div>
                </>
            )
    }
}
